/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BacktestEpisodeChartTradeResponse = {
    trade_id: string;
    order_id: string;
    side: BacktestEpisodeChartTradeResponse.side;
    quantity: string;
    price: string;
    commission: string;
    trading_day: string;
    sequence: number;
};
export namespace BacktestEpisodeChartTradeResponse {
    export enum side {
        BUY = 'BUY',
        SELL = 'SELL',
    }
}

